// Merchandising exclusion for proactive web recommendations only.
// Do not apply to catalogue/search, recently viewed, or purchase eligibility.
const OWN_BRANDS = new Set(['verse', 'pml', 'pomelo', 'pomelo man'])
const EXCLUDED_BRANDS = new Set([
  'tallulah',
  'mynte studio',
  'polarboll',
  'the july mansion',
])

const normalizeBrand = (name) =>
  typeof name === 'string'
    ? name.trim().toLowerCase().replace(/\.$/, '').replace(/\s+/g, ' ')
    : ''

export const isRecommendationEligible = (product) => {
  const manufacturer = product?.manufacturer
  const brand = normalizeBrand(
    typeof manufacturer === 'string'
      ? manufacturer
      : manufacturer?.name || product?.manufacturer_name,
  )
  if (OWN_BRANDS.has(brand)) return true
  // Missing metadata or another brand is not proof of a legacy partnership.
  return !EXCLUDED_BRANDS.has(brand)
}

export const filterRecommendationProducts = (products) =>
  Array.isArray(products) ? products.filter(isRecommendationEligible) : products
